export default __webpack_public_path__ + "static/media/icon-send.309b0438.svg";